// extracted by mini-css-extract-plugin
export default {"buttonDiv":"deleteModal_buttonDiv__f6djr","okButton":"deleteModal_okButton__naZKN","cancelBtn":"deleteModal_cancelBtn__KFche"};